import styles from "./SelectionComplete.module.scss";
import sprite from "../../assets/sprite.svg";
import { genPdf } from "../../helpers/generatePDF";
import React from "react";
import { Wrapper } from "./SelectionComplete.styled";
import detectBrowser from "../../helpers/detectBrowser";

export function SelectionComplete({
  room,
  device,
  selected,
  terminate,
  setTerminate,
  executionType,
  mosaicSelected,
  reformSelected,
}) {
  const openLinkInNewTab = () => {
    const url = "https://siltek.ua/contacts/";
    window.open(url, "_blank");
  };
  const onClickPrint = () => {
    const browser = detectBrowser();
    window.print();
    // browser === "safari"
    //   ? window.print()
    //   : genPdf(reformSelected, room?.background, executionType, mosaicSelected);
  };
  // console.log(selected.length);
  return (
    <Wrapper
      // terminate={terminate || executionType === "mosaic"}
      terminate={terminate}
      className={styles.finish}
      mosaic={executionType === "mosaic"}
    >
      {terminate ? (
        <div className={styles.buttonWrapper}>
          <button
            onClick={openLinkInNewTab}
            type="button"
            style={
              device === "mobile"
                ? {
                    border: "1px solid var(--black)",
                    backgroundColor: "var(--white)",
                    width: "100%",
                  }
                : {
                    backgroundColor: "var(--white)",
                    border: "1px solid var(--black)",
                    marginRight: "20px",
                  }
            }
          >
            <svg style={{ height: "16px", width: "12px", marginRight: "10px" }}>
              <use href={sprite + "#icon-ellipse"} />
            </svg>
            Де купити
          </button>
          <button
            type="button"
            id="pdfButton"
            style={{
              ...{ backgroundColor: "var(--tangerine-yellow)" },
              ...(device === "mobile"
                ? {
                    height: "40px",
                    marginTop: "16px",
                    width: "100%",
                  }
                : {
                    // fontSize: "20px",
                  }),
            }}
            onClick={() => onClickPrint()}
          >
            Роздрукувати
          </button>
        </div>
      ) : (
        <button
          type="button"
          className={styles.closure}
          style={
            selected?.length > 0 || mosaicSelected?.length > 0
              ? {
                  backgroundColor: "var(--tangerine-yellow)",
                  cursor: "pointer",
                }
              : {
                  backgroundColor: "var(--whisper-btnCalc)",
                  cursor: "default",
                  color: "var(--dark)",
                }
          }
          disabled={selected?.length === 0 && mosaicSelected?.length === 0}
          onClick={() => setTerminate(true)}
        >
          Завершити підбір кольорів
        </button>
      )}
    </Wrapper>
  );
}
